import React, { useState } from 'react'
import { FaComment } from 'react-icons/fa'
import CommentItem from './Comments/CommentItem'
import CommentForm from './Comments/CommentForm'
import { useComments } from '../hooks/useComments'

const Comments = ({ eventId, initialComments = [], currentUserId, eventOwnerId }) => {
  const [showComments, setShowComments] = useState(false)
  const { comments, loading, addComment, deleteComment, editComment, addReaction, removeReaction } = useComments(eventId, initialComments)

  return (
    <div className="space-y-4">
      <CommentsToggleButton
        commentsCount={comments.length}
        isOpen={showComments}
        onToggle={() => setShowComments(!showComments)}
      />

      {showComments && (
        <div className="space-y-4 bg-white/5 rounded-xl p-4 border border-white/10">
          {currentUserId && (
            <CommentForm onSubmit={addComment} loading={loading} />
          )}

          <CommentsList
            comments={comments}
            currentUserId={currentUserId}
            eventOwnerId={eventOwnerId}
            onEdit={editComment}
            onDelete={deleteComment}
            onEmojiReaction={addReaction}
            onRemoveReaction={removeReaction}
          />
        </div>
      )}
    </div>
  )
}

const CommentsToggleButton = ({ commentsCount, isOpen, onToggle }) => (
  <button
    onClick={(e) => {
      e.stopPropagation()
      onToggle()
    }}
    className="flex items-center gap-2 px-3 py-2 bg-white/10 text-gray-300 hover:bg-white/20 rounded-lg font-medium transition-all duration-300"
  >
    <FaComment />
    <span className="text-sm">
      {commentsCount} {commentsCount === 1 ? 'Comment' : 'Comments'}
    </span>
  </button>
)

const CommentsList = ({ comments, currentUserId, eventOwnerId, onEdit, onDelete, onEmojiReaction, onRemoveReaction }) => (
  <div className="space-y-3 max-h-60 overflow-y-auto">
    {comments.map((comment) => (
      <CommentItem
        key={comment._id}
        comment={comment}
        currentUserId={currentUserId}
        eventOwnerId={eventOwnerId}
        onEdit={onEdit}
        onDelete={onDelete}
        onEmojiReaction={onEmojiReaction}
        onRemoveReaction={onRemoveReaction}
      />
    ))}

    {comments.length === 0 && <EmptyCommentsMessage />}
  </div>
)

const EmptyCommentsMessage = () => (
  <div className="text-center py-4">
    <p className="text-gray-400 text-sm">No comments yet. Be the first to comment!</p>
  </div>
)

export default Comments